import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router'

import { addBreadcrumb } from '@shared/lib/sentry'

export function CategoryRedirect () {
  const params = useParams()
  
  const pathSegments: string[] = []
  
  if (params.categorySlug) {
    pathSegments.push(params.categorySlug)
  }
  
  if (params.categoryChildrenSlug) {
    pathSegments.push(params.categoryChildrenSlug)
  }
  
  if (params.categorySubChildrenSlug) {
    pathSegments.push(params.categorySubChildrenSlug)
  }
  
  const newPath = pathSegments.length > 0 
    ? `/catalog/${pathSegments.join('/')}`
    : '/catalog'
  
  useEffect(() => {
    const oldPath = window.location.pathname
    addBreadcrumb(
      `URL redirect: ${oldPath} → ${newPath}`,
      'navigation',
      'info'
    )
  }, [ newPath ])
  
  return <Navigate to={newPath} replace />
}
